module.exports = __webpack_public_path__ + "media/rot2.a16b075b.mp4";